module.exports = __webpack_public_path__ + "img/fontello.c207dea6.svg";